import React, { FC } from "react";

import { GeneralInfoBodyBio } from "./GeneralInfoBodyBio";
import { GeneralInfoBodyClinics } from "./GeneralInfoBodyClinics";
import { GeneralInfoBodyPart } from "./GeneralInfoBodyPart";
import { useInsuranceLabels } from "../../../../Utils/Context/labelsContext";
import { InsuranceDoctorDto } from "@apiModels/Insurance/InsuranceDoctorDto.csharp";
import { InsuranceTreaterClinic } from "../../../../../../Pages/InsuranceTreater/InsuranceTreaterClinic.csharp";

interface GeneralInfoBodyProps extends Pick<InsuranceDoctorDto, "bio"> {
  clinics: InsuranceTreaterClinic[];
  insurancePracticalInfo: string;
}

export const GeneralInfoBody: FC<GeneralInfoBodyProps> = (props) => {
  const { clinics, bio, insurancePracticalInfo } = props;

  const { headings } = useInsuranceLabels();

  return (
    <div className="generalInfoBody">
      {clinics && clinics.length > 0 && (
        <GeneralInfoBodyClinics clinics={clinics} />
      )}
      {insurancePracticalInfo && (
        <GeneralInfoBodyPart header={headings.practicalInfoHeading}>
          <div
            className="generalBodyInfoBio__bioIntro"
            dangerouslySetInnerHTML={{
              __html: insurancePracticalInfo,
            }}
          />
        </GeneralInfoBodyPart>
      )}
      {bio && <GeneralInfoBodyBio bio={bio} />}
    </div>
  );
};
